import React from "react";
import { useTranslation } from "react-i18next";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../common/hooks/hooks";
import { useGetVehiclesQuery } from "../../../api/productTaxonomyApi";
import { replaceVehicles } from "../../../productSlice";
import {
  findVehiclePath,
  getVehicleModelOptions,
} from "../../../helpers/vehicleTreeHelpers";

const VehicleFilter: React.FC<{ idPrefix: string }> = ({ idPrefix }) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { category, vehicle } = useAppSelector(
    (state) => state.product.filters,
  );
  const { data: allVehicles = [] } = useGetVehiclesQuery();
  const {
    currentData: available = [],
    isFetching,
    isError,
  } = useGetVehiclesQuery(category);
  const path = findVehiclePath(allVehicles, vehicle[0] ?? null);
  const brand = path[0];
  const availableBrand = available.find((node) => node.id === brand?.id);
  const brands = brand && !availableBrand ? [brand, ...available] : available;
  const models = getVehicleModelOptions(availableBrand);
  const selectedModel = path.length > 1 ? path[path.length - 1].id : null;
  if (
    selectedModel &&
    !models.some((option) => option.value === selectedModel)
  ) {
    models.unshift({
      value: selectedModel,
      label: path
        .slice(1)
        .map((node) => node.name)
        .join(" / "),
    });
  }

  return (
    <div className="filter-widget vehicle-filter" aria-busy={isFetching}>
      <h3 className="filter-widget__title">
        {t("productsArchive.vehicle.title", "Uyumlu Araç")}
      </h3>
      <label htmlFor={`${idPrefix}vehicle-brand`}>
        {t("productsArchive.vehicle.brand", "Araç Markası")}
      </label>
      <select
        id={`${idPrefix}vehicle-brand`}
        className="filter-widget__select"
        value={brand?.id ?? ""}
        disabled={isFetching || isError}
        onChange={(event) =>
          dispatch(
            replaceVehicles(
              event.target.value ? [Number(event.target.value)] : [],
            ),
          )
        }
      >
        <option value="">
          {t("productsArchive.vehicle.allBrands", "Tüm araç markaları")}
        </option>
        {brands.map((node) => (
          <option key={node.id} value={node.id}>
            {node.name}
          </option>
        ))}
      </select>
      <label htmlFor={`${idPrefix}vehicle-model`}>
        {t("productsArchive.vehicle.model", "Araç Modeli")}
      </label>
      <select
        id={`${idPrefix}vehicle-model`}
        className="filter-widget__select"
        value={selectedModel ?? ""}
        disabled={!brand || isFetching || isError}
        onChange={(event) =>
          dispatch(
            replaceVehicles(
              event.target.value
                ? [Number(event.target.value)]
                : brand
                  ? [brand.id]
                  : [],
            ),
          )
        }
      >
        <option value="">
          {t("productsArchive.vehicle.allModels", "Tüm modeller")}
        </option>
        {models.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {isError && (
        <p role="alert">
          {t("productsArchive.vehicle.error", "Araç seçenekleri yüklenemedi.")}
        </p>
      )}
      {!isFetching &&
        !isError &&
        category.length > 0 &&
        available.length === 0 && (
          <p>
            {t(
              "productsArchive.vehicle.empty",
              "Bu kategoride araç uyumluluğu tanımlanmış ürün bulunamadı.",
            )}
          </p>
        )}
    </div>
  );
};

export default VehicleFilter;
